import { tv } from 'tailwind-variants'

export const radioCardSet = tv({
  slots: {
    container: 'flex-1 gap-y-1',
    list: 'flex flex-col gap-y-5 py-0',
  },
  variants: {
    layout: {
      wide: {
        list: 'grow gap-x-0',
      },
      compact: {
        list: [
          'ios:flex-row ios:gap-x-2.5 ios:gap-y-0',
          'android:flex-row android:gap-x-2.5 android:gap-y-0',
          'md:flex-row md:gap-x-2.5 md:gap-y-0',
        ],
      },
    },
    hasTopTags: {
      true: {},
    },
    hasBottomTags: {
      true: {},
    },
  },
})
